import React, { useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import { storage } from "../../utils";
import { useDashboardRole } from "../../context/dashboardRole";

async function authHeaders() {
  const token = await storage.load("token");
  return { "x-auth": token };
}

const MagCategories = () => {
  const { role, loading } = useDashboardRole();
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");

  const load = async () => {
    const headers = await authHeaders();
    await axios.post("/mag/admin/seed_categories", {}, { headers }).catch(() => {});
    const res = await axios.get("/mag/admin/categories", { headers });
    setRows(res.data.data || []);
  };

  useEffect(() => {
    if (role === "owner") load().catch(() => {});
  }, [role]);

  if (!loading && role !== "owner") {
    return <Redirect to="/dashboard/access-denied" />;
  }

  const create = async (e) => {
    e.preventDefault();
    const headers = await authHeaders();
    await axios.post(
      "/mag/admin/categories",
      { name, slug },
      { headers }
    );
    setName("");
    setSlug("");
    await load();
  };

  return (
    <div className="content-body" style={{ padding: "1.5rem" }}>
      <h3>دسته‌بندی‌های پایپ‌مگ</h3>
      <p className="text-muted">
        دسته‌های بدون مقالهٔ منتشرشده در ناوبری عمومی نمایش داده نمی‌شوند.
      </p>
      <form className="form-inline mb-2" onSubmit={create}>
        <input
          className="form-control ml-1"
          placeholder="نام"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          className="form-control ml-1"
          placeholder="اسلاگ"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          dir="ltr"
        />
        <button className="btn btn-primary" type="submit">
          افزودن
        </button>
      </form>
      <ul>
        {rows.map((r) => (
          <li key={r.id}>
            {r.name} <code>{r.slug}</code>{" "}
            {r.is_active ? "" : "(غیرفعال)"}
          </li>
        ))}
      </ul>
      <Link to="/dashboard/mag">بازگشت به مقالات</Link>
    </div>
  );
};

export { MagCategories };
